export enum StoreActivityBranchEnum {
  'food' = 'food',
  'retail' = 'retails',
  'event' = 'event',
  'other' = 'other',
}
